import { useEffect, useState } from "react";
import { Calendar } from "@/components/pages/Calendar";
import { useApi } from "@/api";


const CalendarView = () => {
    const { worker, session } = useApi();

    const [calendarId, setCalendarId] = useState('');

    const getCalendarId = async () =>{
        const calId = await worker.getCalendarId(session.user?.id || '');
        setCalendarId(calId);
    }

    useEffect(()=> {
        getCalendarId();
    }, [calendarId]);

    return (<>
        { calendarId.length > 0 && <Calendar calendarId={calendarId}></Calendar> }
        </>
    );
}

export default CalendarView;